module.exports = __webpack_public_path__ + "assets/img/03-l.659139a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/03-l.jpg
// module id = Ifd5
// module chunks = 0